import { render, staticRenderFns } from "./bigTitle.vue?vue&type=template&id=0a7fa30d&scoped=true"
import script from "./bigTitle.vue?vue&type=script&lang=js"
export * from "./bigTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7fa30d",
  null
  
)

export default component.exports